function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.2",
  height: "17.7",
  viewBox: "0 0 18.2 17.7",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.2 4.05a1 1 0 01.56.17 1 1 0 01.44.83v7.6a1 1 0 01-.62.93L7.45 17.63a1 1 0 01-.93-.1 1 1 0 01-.44-.83V9.1a1 1 0 01.63-.93l10.12-4.05a1 1 0 01.37-.07zm-1 7.92V6.53L8.08 9.78v5.44z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 4.05a1 1 0 01.56.17l6.07 4.05a1 1 0 01.45.83v7.6a1 1 0 01-.53.88 1 1 0 01-1.03-.05L.45 13.48a1 1 0 01-.45-.83v-7.6a1 1 0 01.53-.88A1 1 0 011 4.05zm5.08 5.59L2 6.92v5.2l4.08 2.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.08 10.1a1 1 0 01-.56-.17L.45 5.88A1 1 0 010 4.95a1 1 0 01.62-.83L10.76.07a1 1 0 01.92.1l6.08 4.05a1 1 0 01.44.94 1 1 0 01-.63.82L7.45 10.03a1 1 0 01-.37.07zM3.14 5.27l4.05 2.7 7.88-3.15L11 2.12z"
}))));